// extracted by mini-css-extract-plugin
export var toggled = "RotateIcon-module--toggled--e972a";
export var wrapper = "RotateIcon-module--wrapper--78924";